import { Icon, IconProps } from './Icon';

interface MarkerPinIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const MarkerPinIcon = ({ color = '#5E6A81', gradient, ...props }: MarkerPinIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2766 6.02177V6.02177C20.1909 8.93598 20.1909 13.6608 17.2766 16.5751L13.2434 20.6083C12.5567 21.295 11.4433 21.295 10.7566 20.6083L6.72335 16.5751C3.80914 13.6608 3.80914 8.93598 6.72335 6.02177V6.02177C9.63756 3.10755 14.3624 3.10755 17.2766 6.02177Z"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <circle
      cx="11.9999"
      cy="11.2987"
      r="2.56043"
      stroke={gradient ? `url(#${gradient.id})` : color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
